// namespace
window.Components = window.Components || {};

import domReady from '@wordpress/dom-ready';

(function($) {

  'use strict';

  function customFilter() {

    const self = this,
        $cache = {};

    /**
     * Init Cache
     *
     * @param  {Object} target jQuery-wrapped root element
     */
    function initCache(target) {
        $cache.filter = target;
        $cache.default = $cache.filter.find('.default');
        $cache.listWrapper = $cache.filter.find('.list-wrapper');
        $cache.listHide = $cache.filter.find('.list-hide');
    }

    function openFilter() {
      if ($cache.isOpen) return;

      $cache.isOpen = true;
      $cache.listWrapper.height($cache.listHide.outerHeight());
      $cache.listHide.addClass('is-active');
    }

    function closeFilter() {
      if (!$cache.isOpen) return;

      $cache.isOpen = false;
      $cache.listWrapper.height(0);
      $cache.listHide.removeClass('is-active');
    }

    function toggleFilter() {
      if ($cache.isOpen) {
        closeFilter();
      } else {
        openFilter();
      }
    }

    /**
     * Register Events
     */
    function registerEvents() {

        $cache.default.on('click', function(event) {
            event.stopPropagation();
            toggleFilter();
        });

        $(document).on('click', function(event) {
            if ($cache.isOpen && !$cache.filter.is(event.target) && $cache.filter.has(event.target).length === 0) {
                closeFilter();
            }
        });
    }

    /**
     * Public constructor
     *
     * @param  {Object} target jQuery-wrapped root element
     */
    self.initialize = function(target) {
        initCache(target);
        registerEvents();

        $cache.isOpen = false;
    };

    self.initialize.apply(self, arguments);
    return self;
  }

  window.Components.customFilter = customFilter;

  domReady(() => {
    $('[data-component="customFilter"]').each(function() {
      new window.Components.customFilter($(this));
    });
  });

}(jQuery));
